module.exports = __webpack_public_path__ + "static/img/gene_interference_flow.9d88d8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/基因调控/基因干扰/gene_interference_flow.png
// module id = 1egj
// module chunks = 16